import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-notes-modal',
  templateUrl: './notes-modal.component.html',
  styleUrls: ['./notes-modal.component.css']
})
export class NotesModalComponent implements OnInit {
  @Output() closeModal = new EventEmitter<any>();
  @Input() notes:any;
  constructor(){}
  ngOnInit() {
    console.log("notes",this.notes);
  }

  onCloseModal() {
    this.closeModal.emit();
  }
}
